const yesNoSufferTradingLosses = {
    yes: 'Oui',
    no: 'Non',
};

export default yesNoSufferTradingLosses;
